import { languages } from './languages';

export const languageCodes = Object.freeze(
  languages.map(({ languageCode }) => languageCode),
);
